export default {
  lang: 'sl',
  dir: 'ltr',
  common: {
    ok: 'V redu',
    cancel: 'Prekliči',
    key_backspace: 'backspace',
    key_del: 'delete',
    key_down: 'dol',
    key_up: 'gor',
    more_opts: 'Več možnosti',
    url: 'URL',
    width: 'širina',
    height: 'višina'
  },
  misc: {
    powered_by: 'Izdelano z'
  },
  ui: {
    toggle_stroke_tools: 'Pokaži/skrij več orodij za oris',
    palette_info: 'Kliknite, če želite spremeniti barvo polnila, kliknite+Shift, če želite spremeniti barvo orisa',
    zoom_level: 'Povečava',
    panel_action: 'Click to open side panel',
    quality: 'Quality:',
    pathNodeTooltip: 'Drag node to move it. Double-click node to change segment type',
    pathCtrlPtTooltip: 'Drag control point to adjust curve properties',
    pick_stroke_paint_opacity: 'Pick a Stroke Paint and Opacity',
    pick_fill_paint_opacity: 'Pick a Fill Paint and Opacity',
    group_identify_label: 'Group identification label',
    export_type_label: 'Select an image type for export:'
  },
  properties: {
    id: 'ID elementa',
    fill_color: 'Spremeni barvo polnila',
    stroke_color: 'Spremeni barvo orisa',
    stroke_style: 'Spremeni slog orisa',
    stroke_width: 'Spreminjanje širino orisa',
    pos_x: 'Spremeni X koordinato',
    pos_y: 'Spremeni Y koordinato',
    linecap_butt: 'Začetek črte: odsekan',
    linecap_round: 'Začetek črte: zaobljen',
    linecap_square: 'Začetek črte: kvadraten',
    linejoin_bevel: 'Ovinek črte: Odsekan',
    linejoin_miter: 'Linejoin: V kot',
    linejoin_round: 'Linejoin: Zaobljen',
    angle: 'Spremeni kot zasuka',
    blur: 'Spremeni zameglitev roba',
    opacity: 'Spremeni prosojnost',
    circle_cx: 'Spremeni CX koordinato',
    circle_cy: 'Spremeni CY koordinato',
    circle_r: 'Spremeni polmer kroga',
    ellipse_cx: 'Spremeni CX koordinato',
    ellipse_cy: 'Spremeni CY koordinato',
    ellipse_rx: 'Spremeni X polmer',
    ellipse_ry: 'Spremeni Y polmer',
    line_x1: 'Spremeni začetno X koordinato',
    line_x2: 'Spremeni končno X koordinato',
    line_y1: 'Spremeni začetno Y koordinato',
    line_y2: 'Spremeni končno Y koordinato',
    rect_height: 'Spremeni višino pravokotnika',
    rect_width: 'Spremeni širino pravokotnika',
    corner_radius: 'Spremeni Pravokotnik Corner Radius',
    image_width: 'Spremeni širino slike',
    image_height: 'Spremeni višino slike',
    image_url: 'Spremeni URL',
    node_x: 'Spremeni X koordinato oglišča',
    node_y: 'Spremeni Y koordinato oglišča',
    seg_type: 'Spremeni vrsto odseka',
    straight_segments: 'Raven odsek',
    curve_segments: 'Ukrivljen odsek',
    text_contents: 'Spremeni besedilo',
    font_family_label: 'Font:',
    font_family: 'Spremeni tip pisave',
    font_size: 'Spremeni velikost pisave',
    bold: 'Krepko',
    text_decoration_underline: 'Underline',
    text_decoration_linethrough: 'Line-Through',
    text_decoration_overline: 'Overline',
    italic: 'Poševno',
    text_anchor_start: 'Align the text in start',
    text_anchor_middle: 'Align the text in middle',
    text_anchor_end: 'Align the text in end',
    text_letter_spacing: 'Change the letter spacing',
    text_word_spacing: 'Change the word spacing',
    text_length: 'Lets you specify the width of the space into which the text will draw',
    text_length_adjust: 'Length adjust',
    text_length_adjust_spacing: 'Spacing',
    text_length_adjust_spacing_and_glyphs: 'Spacing & Glyphs',
    class: 'Element class',
    serif: 'Serif',
    sans_serif: 'Sans-serif',
    cursive: 'Cursive',
    fantasy: 'Fantasy',
    monospace: 'Monospace',
    courier: 'Courier',
    helvetica: 'Helvetica',
    times: 'times',
    prefs_and_content: 'Store preferences and SVG content locally',
    prefs_only: 'Only store preferences locally',
    no_prefs_or_content: 'Do not store my preferences or SVG content locally',
    jgraduate_pad: 'Pad',
    jgraduate_reflect: 'Reflect',
    jgraduate_repeat: 'Repeat'
  },
  tools: {
    main_menu: 'Glavni meni',
    bkgnd_color_opac: 'Spremeni barvo / prosojnost',
    connector_no_arrow: 'Brez puščice',
    fitToContent: 'Prilagodi vsebini',
    fit_to_all: 'Prilagodi vsemu',
    fit_to_canvas: 'Prilagodi sliki',
    fit_to_layer_content: 'Prilagodi sloju',
    fit_to_sel: 'Prilagodi izboru',
    align_relative_to: 'Poravnaj glede na ...',
    relativeTo: 'glede na:',
    page: 'page',
    largest_object: 'največji objekt',
    selected_objects: 'izbrani objekt',
    smallest_object: 'najmanjši objekt',
    new_doc: 'Nova slika',
    open_doc: 'Odpri sliko',
    export_img: 'Izvozi v PNG',
    save_doc: 'Shrani sliko',
    import_doc: 'Uvozi SVG',
    align_to_page: 'Poravnaj na stran',
    align_bottom: 'Poravnaj na dno',
    align_center: 'Poravnaj na sredino',
    align_left: 'Poravnaj levo',
    align_middle: 'Poravnaj na sredino',
    align_right: 'Poravnaj desno',
    align_top: 'Poravnaj na vrh',
    mode_select: 'Izberi',
    mode_fhpath: 'Svinčnik',
    mode_line: 'Crta',
    mode_rect: 'Pravokotnik',
    mode_square: 'Kvadrat',
    mode_fhrect: 'Prostoročni pravokotnik',
    mode_ellipse: 'Elipsa',
    mode_circle: 'Krog',
    mode_fhellipse: 'Prostoročna elipsa',
    mode_path: 'Pot',
    mode_text: 'Besedilo',
    mode_image: 'Slika',
    mode_zoom: 'Povečava',
    no_embed: 'OPOMBA: Ta slika ne more biti vključena. It will depend on this path to be displayed',
    undo: 'Razveljavi',
    redo: 'Uveljavi',
    tool_source: 'Uredi vir',
    wireframe_mode: 'Wireframe način',
    clone: 'Kloniraj element(e)',
    del: 'Izbriši element(e)',
    group_elements: 'Združi element(e)',
    make_link: 'Vstavi (hiper)povezavo',
    set_link_url: 'Set link URL (leave empty to remove)',
    to_path: 'Pretvori v pot',
    reorient_path: 'Reorient pot',
    ungroup: 'Razdruži elemente',
    docprops: 'Lastnosti dokumenta',
    editor_homepage: 'SVG-Edit Home Page',
    move_bottom: 'Premakni na dno',
    move_top: 'Premakni na vrh',
    node_clone: 'Kloniraj oglišče',
    node_delete: 'Izbriši oglišče',
    node_link: 'Link Control Points',
    add_subpath: 'Add sub-path',
    openclose_path: 'Open/close sub-path',
    source_save: 'Shrani',
    cut: 'Izreži',
    copy: 'Kopiraj',
    paste: 'Prilepi',
    paste_in_place: 'Prilepi na mesto',
    delete: 'Izbriši',
    group: 'Združi',
    move_front: 'Postavi v ospredje',
    move_up: 'Pomakni naporej',
    move_down: 'Pomakni nazaj',
    move_back: 'Postavi v ozadje',
    tool_unlink_use: 'Break link to reference element (make unique)',
    ellipse_circle_tool: 'Ellipse/Circle Tool',
    square_rect_tool: 'Square/Rect Tool',
    remember_this_choice: 'Remember this choice?',
    remember_this_choice_title: 'If you choose to opt out of storage while remembering this choice, the URL will change so as to avoid asking again.'
  },
  layers: {
    layer: 'Sloj',
    layers: 'Sloji',
    del: 'Izbriši sloj',
    move_down: 'Premakni navzdol',
    new: 'Nov sloj',
    rename: 'Preimenuj sloj',
    move_up: 'Premakni navzgor',
    dupe: 'Podvoji sloj',
    merge_down: 'Združi s spodnjimi',
    merge_all: 'Združi vse',
    move_elems_to: 'Premakni elemente v:',
    move_selected: 'Premakne elemente v drug sloj'
  },
  config: {
    image_props: 'Lastnosti slike',
    doc_title: 'Naslov',
    doc_dims: 'Dimenzije slike',
    included_images: 'Vključene slike',
    image_opt_embed: 'Vključene (local files)',
    image_opt_ref: 'Povezane (Use file reference)',
    editor_prefs: 'Lastnosti urejevalnika',
    language: 'Jezik',
    background: 'Ozadje urejevalnika',
    editor_img_url: 'URL slike',
    editor_bg_note: 'OPOMBA: Ozdaje ne bo shranjeno s sliko.',
    select_predefined: 'Izberi prednastavljeno:',
    units_and_rulers: 'Enote & ravnilo',
    show_rulers: 'Pokaži ravnilo',
    base_unit: 'Osnovne enote',
    grid: 'Mreža',
    snapping_onoff: 'Pripni na mrežo DA/NE',
    snapping_stepsize: 'Snapping Step-Size:',
    grid_color: 'Grid color',
    done: 'Done',
    change_xxx_color: 'Change xxx color',
    pick_paint_opavity: 'Pick a {{newValue}} Paint and Opacity',
    open_color_picker: 'Click To Open Color Picker',
    jpicker_title: 'Drag Markers To Pick A Color',
    jpicker_new_color: 'new',
    jpicker_current_color: 'current',
    jpicker_tooltip_colors_new_color: 'New Color - Press &ldquo;OK&rdquo; To Commit',
    jpicker_tooltip_colors_current_color: 'Click To Revert To Original Color',
    jpicker_tooltip_buttons_ok: 'Commit To This Color Selection',
    jpicker_tooltip_buttons_cancel: 'Cancel And Revert To Original Color',
    jpicker_tooltip_hue_radio: 'Set To &ldquo;Hue&rdquo; Color Mode',
    jpicker_tooltip_hue_textbox: 'Enter A &ldquo;Hue&rdquo; Value (0-360&deg;)',
    jpicker_tooltip_saturation_radio: 'Set To &ldquo;Saturation&rdquo; Color Mode',
    jpicker_tooltip_saturation_textbox: 'Enter A &ldquo;Saturation&rdquo; Value (0-100%)',
    jpicker_tooltip_value_radio: 'Set To &ldquo;Value&rdquo; Color Mode',
    jpicker_tooltip_value_textbox: 'Enter A &ldquo;Value&rdquo; Value (0-100%)',
    jpicker_tooltip_red_radio: 'Set To &ldquo;Red&rdquo; Color Mode',
    jpicker_tooltip_red_textbox: 'Enter A &ldquo;Red&rdquo; Value (0-255)',
    jpicker_tooltip_green_radio: 'Set To &ldquo;Green&rdquo; Color Mode',
    jpicker_tooltip_green_textbox: 'Enter A &ldquo;Green&rdquo; Value (0-255)',
    jpicker_tooltip_blue_radio: 'Set To &ldquo;Blue&rdquo; Color Mode',
    jpicker_tooltip_blue_textbox: 'Enter A &ldquo;Blue&rdquo; Value (0-255)',
    jpicker_tooltip_alpha_radio: 'Set To &ldquo;Alpha&rdquo; Color Mode',
    jpicker_tooltip_alpha_textbox: 'Enter A &ldquo;Alpha&rdquo; Value (0-100)',
    jpicker_tooltip_hex_textbox: 'Enter A &ldquo;Hex&rdquo; Color Value (#000000-#ffffff)',
    jpicker_tooltip_hex_alpha: 'Enter A &ldquo;Alpha&rdquo; Value (#00-#ff)',
    jgraduate_solid_color: 'Solid Color',
    jgraduate_linear_gradient: 'Linear Gradient',
    jgraduate_radial_gradient: 'Radial Gradient',
    jgraduate_begin_point: 'Begin Point',
    jgraduate_enter_starting_x: 'Enter starting x value between 0.0 and 1.0',
    jgraduate_enter_starting_y: 'Enter starting y value between 0.0 and 1.0',
    jgraduate_end_point: 'End Point',
    jgraduate_enter_ending_x: 'Enter ending x value between 0.0 and 1.0',
    jgraduate_enter_ending_y: 'Enter ending y value between 0.0 and 1.0',
    jgraduate_center_point: 'Center Point',
    jgraduate_enter_value_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_value_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_focal_point: 'Focal Point',
    jgraduate_match_center: 'Match center:',
    jgraduate_enter_focal_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_focal_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_spread_method: 'Spread method',
    jgraduate_radius: 'Radius:',
    jgraduate_set_radius: 'Click to set radius',
    jgraduate_ellip: 'Ellip:',
    jgraduate_set_ellip: 'Click to set Ellip',
    jgraduate_angle: 'Angle:',
    jgraduate_set_angle: 'Click to set Angle',
    jgraduate_deg: 'deg:',
    jgraduate_opac: 'Opac:',
    jgraduate_set_opac: 'Click to set Opac'
  },
  notification: {
    invalidAttrValGiven: 'Napačna vrednost!',
    noContentToFitTo: 'Ni vsebine za prilagajanje',
    dupeLayerName: 'Sloj s tem imenom že obstajal!',
    enterUniqueLayerName: 'Vnesite edinstveno ime sloja',
    enterNewLayerName: 'Vnesite ime novega sloja',
    layerHasThatName: 'Sloje že ima to ime',
    QmoveElemsToLayer: "Premaknem izbrane elemente v sloj '%s'?",
    QwantToClear: 'Ali želite počistiti risbo?\nTo bo izbrisalo tudi zgodovino korakov (ni mogoče razveljaviti)!',
    QwantToOpen: 'Ali želite odpreti novo datoteko?\nTo bo izbrisalo tudi zgodovino korakov (ni mogoče razveljaviti)!',
    QerrorsRevertToSource: 'There were parsing errors in your SVG source.\nRevert back to original SVG source?',
    QignoreSourceChanges: 'Ignoriram spremembe, narejene v SVG kodi?',
    featNotSupported: 'Ni podprto',
    enterNewImgURL: 'Vnesite nov URL slike',
    defsFailOnSave: 'OPOMBA: Zaradi napake vašega brskalnika obstaja možnost, da ta slika ni prikazan pravilno (manjkajo določeni elementi ali gradient). Vseeno bo prikaz pravilen, ko bo slika enkrat shranjena.',
    loadingImage: 'Nalagam sliko, prosimo, počakajte ...',
    saveFromBrowser: "Select 'Save As...' in your browser (possibly via file menu or right-click context-menu) to save this image as a {{type}} file.",
    noteTheseIssues: 'Also note the following issues: ',
    unsavedChanges: 'Obstajajo neshranjene spremembe.',
    enterNewLinkURL: 'Vnesite novo URL povezavo',
    errorLoadingSVG: 'Napaka: Ne morem naložiti SVG podatkov',
    URLLoadFail: 'Ne morem naložiti z URL',
    retrieving: 'Retrieving \'%s\' ...',
    popupWindowBlocked: 'Popup window may be blocked by browser',
    exportNoBlur: 'Blurred elements will appear as un-blurred',
    exportNoforeignObject: 'foreignObject elements will not appear',
    exportNoDashArray: 'Strokes will appear filled',
    exportNoText: 'Text may not appear as expected',
    editorPreferencesMsg: 'By default and where supported, SVG-Edit can store your editor preferences and SVG content locally on your machine so you do not need to add these back each time you load SVG-Edit. If, for privacy reasons, you do not wish to store this information on your machine, you can change away from the default option below.',
    source_dialog_note: 'Copy the contents of this box into a text editor, then save the file with a .svg extension.'
  }
}
